import React from "react";
import { connect } from "react-redux";
import { clearNextBounds } from "../../Redux/actions/mapData.js";
import MapView from "./components/MapView.js";

const LeafletContainer = (props) => {
  const { geojson, markersVisible, tenementsLayerVisible, nextBounds, projects, mapLayers, sidebarItems, clearNextBounds } = props;

  return (
    <MapView
      geojson={geojson}
      markersVisible={markersVisible}
      tenementsLayerVisible={tenementsLayerVisible}
      nextBounds={nextBounds}
      projects={projects}
      mapLayers={mapLayers}
      sidebarItems={sidebarItems}
      clearNextBounds={clearNextBounds}
    />
  );
};

const mapStateToProps = (state) => ({
  geojson: state.mapData.geojson,
  markersVisible: state.mapData.markersVisible,
  tenementsLayerVisible: state.mapData.tenementsLayerVisible,
  nextBounds: state.mapData.nextBounds,
  mapLayers: state.mapTileLayers,
  sidebarItems: state.sidebarItems,
});

const mapDispatchToProps = (dispatch) => ({
  clearNextBounds: () => dispatch(clearNextBounds()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeafletContainer);
